<template>
  <div class="GaugeLoader">
    Loading...
  </div>
</template>
